module.exports = __webpack_public_path__ + "img/QRCode.c4cf36b4.png";